import { combine, createEffect, restore, sample } from 'effector'
import { model as i18nModel } from '~/core/i18n'
import { model as config, remote } from '~/shared/config'
import { formatRemoteLanguages } from './lib'

const parseFx = createEffect<string, Array<{ id: string; value: string }>>(
  formatRemoteLanguages
)

const $remoteLanguages = config.get(remote.tria_languages)

export const $fBLanguages = restore(parseFx.doneData, null)

export const $languages = combine(
  $fBLanguages,
  i18nModel.$languagesFromNora,
  i18nModel.$noraLocalizationEnabled,
  (fBLanguages, languagesFromNora, noraLocalizationEnabled) => {
    if (noraLocalizationEnabled != null) {
      return noraLocalizationEnabled ? languagesFromNora : fBLanguages
    }

    return null
  }
)

sample({
  clock: $remoteLanguages,
  target: parseFx,
})
